/* Northstar Studios — original Mare Island waterfront canvas illustration.
 * All scenery is periodic and deterministic. Day/night changes light, never geometry.
 * API: NorthstarWaterfront.draw(ctx, { width, height, distance, night, time }).
 * distance is the game-world distance in pixels; night is a blend in [0, 1].
 * time is elapsed seconds (used only for subtle ripples).
 */
(function () {
  'use strict';
  var TAU = Math.PI * 2;
  var PERIOD = 1440;
  var stars = [];
  for (var s = 0; s < 42; s++) stars.push([(s * 97 + 13) % 420, 35 + (s * 73) % 300, s % 3 === 0 ? 1.35 : 0.8]);

  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  function mix(a, b, n) {
    return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * n) + ',' +
      Math.round(a[1] + (b[1] - a[1]) * n) + ',' + Math.round(a[2] + (b[2] - a[2]) * n) + ')';
  }
  function poly(c, points, color) {
    c.fillStyle = color; c.beginPath(); c.moveTo(points[0], points[1]);
    for (var i = 2; i < points.length; i += 2) c.lineTo(points[i], points[i + 1]);
    c.closePath(); c.fill();
  }
  function line(c, points, color, width) {
    c.strokeStyle = color; c.lineWidth = width; c.beginPath(); c.moveTo(points[0], points[1]);
    for (var i = 2; i < points.length; i += 2) c.lineTo(points[i], points[i + 1]);
    c.stroke();
  }
  function rect(c, x, y, w, h, color) { c.fillStyle = color; c.fillRect(x, y, w, h); }
  function circle(c, x, y, r, color) { c.fillStyle = color; c.beginPath(); c.arc(x, y, r, 0, TAU); c.fill(); }
  function loop(c, distance, speed, painter, left, right) {
    var offset = ((distance * speed) % PERIOD + PERIOD) % PERIOD;
    // Only repeat tiles whose painted extent intersects the 420px world viewport.
    // Bounds include any artwork extending beyond a nominal tile edge.
    left = left == null ? 0 : left;
    right = right == null ? PERIOD : right;
    var first = Math.floor((offset - right) / PERIOD) + 1;
    var last = Math.ceil((offset + 420 - left) / PERIOD) - 1;
    for (var k = first; k <= last; k++) {
      c.save(); c.translate(k * PERIOD - offset, 0); painter(c); c.restore();
    }
  }
  function cloud(c, x, y, size, n) {
    c.save(); c.translate(x, y); c.scale(size, size); c.globalAlpha = 0.55 * (1 - n);
    c.fillStyle = '#fff9e6'; c.beginPath(); c.moveTo(-48, 12);
    c.bezierCurveTo(-60, -2, -39, -12, -25, -5);
    c.bezierCurveTo(-25, -30, 6, -34, 14, -12);
    c.bezierCurveTo(39, -23, 49, -6, 43, 1);
    c.bezierCurveTo(63, 0, 66, 15, 48, 17); c.closePath(); c.fill(); c.restore();
  }
  function hills(c, n) {
    poly(c, [0, 488, 0, 449, 60, 427, 113, 441, 181, 410, 246, 434, 324, 416,
      402, 442, 491, 424, 563, 448, 628, 414, 699, 423, 780, 398, 876, 429,
      952, 409, 1034, 437, 1103, 422, 1200, 446, 1300, 422, 1370, 441, 1440, 449, 1440, 488],
    mix([132, 176, 170], [39, 49, 75], n));
    poly(c, [0, 506, 0, 467, 85, 451, 159, 468, 244, 452, 316, 469, 400, 455,
      487, 473, 564, 458, 642, 475, 740, 449, 831, 469, 910, 450, 1000, 473,
      1081, 459, 1186, 480, 1290, 456, 1367, 470, 1440, 467, 1440, 506],
    mix([99, 153, 149], [31, 47, 67], n));
  }
  function warehouse(c, x, y, w, h, n, roof) {
    var wall = mix([175, 190, 165], [39, 61, 71], n);
    rect(c, x, y, w, h, wall);
    poly(c, [x - 3, y + 2, x + w * 0.5, y - roof, x + w + 3, y + 2], mix([111, 145, 137], [35, 48, 63], n));
    rect(c, x, y + h - 5, w, 5, mix([103, 143, 136], [25, 40, 56], n));
    for (var z = 8; z < w - 8; z += 17) {
      rect(c, x + z, y + 10, 9, 9, mix([85, 131, 132], [211, 177, 101], n * (z % 3 ? 1 : 0.3)));
      rect(c, x + z, y + 21, 9, Math.max(0, h - 27), mix([132, 163, 151], [33, 48, 62], n));
    }
  }
  function crane(c, x, y, scale, n, lean) {
    c.save(); c.translate(x, y); c.scale(scale, scale);
    var dark = mix([85, 125, 124], [42, 65, 80], n);
    var gold = mix([192, 161, 94], [120, 112, 86], n);
    line(c, [-18, 0, 0, -102, 17, 0], dark, 5);
    line(c, [-15, -18, 13, -18, -10, -41, 9, -41, -6, -66, 5, -66, 0, -102], gold, 2);
    line(c, [0, -89, lean, -157, lean + 10, -147, 11, -80], dark, 4);
    line(c, [0, -89, lean + 10, -147], gold, 1.7);
    line(c, [lean, -157, lean, -67, lean + 5, -61, lean + 9, -65], dark, 1.2);
    line(c, [-27, -55, 25, -55], dark, 5);
    rect(c, -13, -64, 30, 16, gold); rect(c, 4, -61, 10, 7, dark);
    if (n > 0.01) { c.globalAlpha = n; circle(c, lean, -157, 1.7, '#f67b69'); }
    c.restore();
  }
  function ship(c, x, y, scale, n) {
    c.save(); c.translate(x, y); c.scale(scale, scale);
    poly(c, [0, -25, 15, 0, 150, 0, 174, -25], mix([70, 114, 125], [28, 44, 63], n));
    rect(c, 32, -43, 93, 18, mix([177, 192, 178], [69, 87, 91], n));
    rect(c, 52, -56, 47, 13, mix([201, 208, 183], [80, 94, 94], n));
    rect(c, 83, -71, 5, 15, mix([95, 133, 130], [31, 47, 63], n));
    line(c, [59, -56, 59, -91, 70, -80], mix([95, 133, 130], [74, 96, 107], n), 1.4);
    for (var i = 0; i < 6; i++) rect(c, 40 + i * 13, -39, 5, 4, mix([74, 126, 139], [241, 206, 124], n));
    line(c, [10, -20, 163, -20], mix([196, 193, 155], [141, 131, 101], n), 2);
    c.restore();
  }
  function shoreline(c, n) {
    rect(c, 0, 512, PERIOD, 20, mix([91, 142, 135], [24, 44, 61], n));
    warehouse(c, 2, 482, 95, 37, n, 11);
    warehouse(c, 331, 486, 100, 34, n, 9);
    warehouse(c, 437, 477, 77, 42, n, 15);
    warehouse(c, 531, 485, 139, 35, n, 5);
    warehouse(c, 962, 482, 104, 37, n, 14);
    warehouse(c, 1081, 491, 95, 29, n, 7);
    warehouse(c, 1193, 477, 152, 43, n, 12);
    crane(c, 395, 507, 0.72, n, -50);
    crane(c, 574, 509, 0.86, n, 40);
    crane(c, 652, 510, 0.65, n, -43);
    crane(c, 1247, 509, 0.8, n, 44);
    ship(c, 739, 535, 1.1, n);
    ship(c, 1333, 530, 0.55, n);
    for (var j = 17; j < PERIOD; j += 57) {
      rect(c, j, 522, 4, 16, mix([67, 116, 116], [20, 36, 54], n));
    }
  }
  function tower(c, x, n) {
    var frame = mix([57, 148, 160], [35, 90, 114], n);
    var light = mix([134, 203, 198], [96, 198, 222], n);
    var shade = mix([43, 114, 137], [25, 60, 90], n);
    rect(c, x + 4, 371, 23, 164, frame);
    rect(c, x + 24, 371, 8, 164, shade);
    rect(c, x + 8, 402, 13, 31, mix([128, 180, 174], [31, 49, 76], n));
    rect(c, x + 8, 442, 13, 32, mix([143, 188, 177], [31, 49, 76], n));
    rect(c, x + 8, 483, 13, 41, mix([136, 181, 166], [32, 49, 73], n));
    rect(c, x + 3, 369, 24, 30, mix([237, 228, 183], [57, 89, 110], n));
    rect(c, x + 26, 369, 7, 30, shade);
    rect(c, x + 7, 374, 3, 19, mix([154, 187, 168], [108, 207, 229], n));
    rect(c, x + 5, 400, 3, 127, light);
    rect(c, x + 2, 435, 26, 7, frame);
    rect(c, x + 2, 475, 26, 7, frame);
    rect(c, x + 2, 435, 25, 2, light);
    rect(c, x + 2, 475, 25, 2, light);
    rect(c, x - 3, 534, 41, 13, mix([85, 128, 125], [21, 37, 55], n));
    if (n > 0.001) {
      c.save(); c.globalAlpha = n * 0.75;
      rect(c, x + 6, 401, 2, 32, '#8ce5e4'); rect(c, x + 25, 445, 2, 27, '#80cde3');
      circle(c, x + 19, 520, 2, '#fa6b59'); c.restore();
    }
  }
  function bridge(c, n) {
    var beam = mix([70, 144, 152], [37, 75, 95], n);
    rect(c, 0, 526, 355, 8, beam);
    for (var i = 11; i < 355; i += 27) {
      rect(c, i, 520, 2, 9, mix([153, 191, 173], [89, 121, 121], n));
      if (i < 92 || i > 271) rect(c, i, 535, 6, 20, mix([73, 123, 125], [21, 38, 56], n));
    }
    line(c, [0, 520, 355, 520], mix([182, 209, 182], [146, 167, 137], n), 1.5);
    rect(c, 99, 523, 159, 11, mix([78, 166, 177], [37, 104, 132], n));
    rect(c, 99, 523, 159, 2, mix([140, 204, 192], [93, 184, 198], n));
    tower(c, 84, n); tower(c, 240, n);
    if (n > 0.001) {
      c.save(); c.globalAlpha = n;
      for (var z = 16; z < 350; z += 27) circle(c, z, 520, 1.2, '#ffe2a1');
      c.restore();
    }
  }
  function reflection(c, x, y, length, width, color, alpha, t) {
    if (alpha <= 0) return;
    c.save(); c.fillStyle = color;
    for (var i = 0; i < 15; i++) {
      c.globalAlpha = alpha * (1 - i / 15) * (i % 3 === 0 ? 0.8 : 0.48);
      var yy = y + i * length / 15;
      var drift = Math.sin(i * 1.9 + t * 0.65) * (2 + i * 0.23);
      c.fillRect(x + drift - width / 2 - i * 0.25, yy, width + i * 0.5, 2 + i * 0.2);
    }
    c.restore();
  }

  function draw(c, options) {
    if (!c || !options || !(options.width > 0) || !(options.height > 0)) return;
    var n = clamp(Number(options.night) || 0);
    var d = Number.isFinite(options.distance) ? options.distance : 0;
    var t = Number.isFinite(options.time) ? options.time : 0;
    var sunset = Math.sin(n * Math.PI);
    c.save(); c.scale(options.width / 420, options.height / 700);
    var sky = c.createLinearGradient(0, 0, 0, 550);
    sky.addColorStop(0, mix([119, 188, 192], [17, 27, 55], n));
    sky.addColorStop(0.62, mix([191, 218, 194], [49, 64, 89], n));
    sky.addColorStop(1, mix([244, 228, 183], [109, 104, 119], n));
    c.fillStyle = sky; c.fillRect(0, 0, 420, 700);
    if (sunset > 0.01) {
      var dusk = c.createLinearGradient(0, 280, 0, 525);
      dusk.addColorStop(0, 'rgba(238,155,117,0)');
      dusk.addColorStop(1, 'rgba(238,155,117,' + sunset * 0.65 + ')');
      c.fillStyle = dusk; c.fillRect(0, 280, 420, 260);
    }
    if (n < 1) {
    c.save(); c.globalAlpha = 1 - n;
    circle(c, 332, 134 + n * 220, 40, 'rgba(255,244,204,0.13)');
    circle(c, 332, 134 + n * 220, 29, '#fff0bf'); c.restore();
    }
    if (n > 0) {
    c.save(); c.globalAlpha = n;
    for (var si = 0; si < stars.length; si++) circle(c, stars[si][0], stars[si][1], stars[si][2], '#e6e6cc');
    circle(c, 332, 110, 21, '#e5e4cc');
    circle(c, 337, 105, 19, mix([119, 188, 192], [23, 34, 62], n));
    c.restore();
    }
    if (n < 1) loop(c, d, 0.08, function (ctx) {
      cloud(ctx, 85, 175, 1.15, n); cloud(ctx, 382, 279, 0.75, n);
      cloud(ctx, 674, 124, 1.5, n); cloud(ctx, 1012, 236, 1.1, n); cloud(ctx, 1300, 147, 0.7, n);
    });
    loop(c, d, 0.16, function (ctx) { hills(ctx, n); });
    var water = c.createLinearGradient(0, 522, 0, 700);
    water.addColorStop(0, mix([105, 171, 168], [40, 70, 94], n));
    water.addColorStop(0.5, mix([76, 153, 157], [26, 55, 78], n));
    water.addColorStop(1, mix([50, 128, 140], [18, 39, 63], n));
    c.fillStyle = water; c.fillRect(0, 522, 420, 178);
    loop(c, d, 0.29, function (ctx) {
      shoreline(ctx, n); bridge(ctx, n);
      reflection(ctx, 98, 549, 124, 14, mix([92, 143, 141], [90, 220, 237], n), 0.22 + n * 0.46, t);
      reflection(ctx, 255, 549, 123, 12, mix([92, 143, 141], [103, 201, 230], n), 0.22 + n * 0.42, t);
      reflection(ctx, 418, 538, 85, 5, '#f6c875', n * 0.6, t);
      reflection(ctx, 620, 538, 110, 7, '#f6c875', n * 0.5, t);
      reflection(ctx, 860, 542, 79, 12, '#e6bf81', n * 0.25, t);
      reflection(ctx, 1290, 538, 100, 6, '#f6c875', n * 0.5, t);
    }, -2, PERIOD);
    // Independently wrapped water marks establish a gentle foreground parallax.
    loop(c, d, 0.47, function (ctx) {
      ctx.save(); ctx.globalAlpha = 0.24;
      for (var r = 0; r < 65; r++) {
        var x = (r * 131 + 31) % PERIOD;
        var y = 553 + ((r * 37) % 143);
        var w = 7 + (r % 5) * 5;
        rect(ctx, x + Math.sin(t * 0.6 + r) * 2, y, w, r % 3 === 0 ? 2 : 1,
          mix([190, 223, 199], [109, 151, 169], n));
      }
      ctx.restore();
    }, -2, PERIOD + 28);
    c.restore();
  }
  window.NorthstarWaterfront = Object.freeze({ draw: draw });
}());
